import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
declare var $;

@Component({
  selector: 'app-modal',
    exportAs: 'modal',
    templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.sass']
})
export class ModalComponent implements OnInit, OnDestroy {

  constructor( private router : Router) {

  }


  ngOnInit() {
    $('#myModal').modal('show');
    $('#myModal').on('hide.bs.modal', this.remove);
  }
    ngOnDestroy() {
        this.remove();
    }

    remove = () => {
        $('.modal-backdrop').remove();
        this.router.navigate([{outlets: {modal: null}}]);
    }

    modalClose( ) {
        this.router.navigate([{outlets: {modal: null}}]);
        $('#myModal').modal('hide');
    }
}
